module.exports = __webpack_public_path__ + "media/images/lb/420-439ed88ff92e99f52be13e7285cefe0f.svg";